module.exports = __webpack_public_path__ + "img/mobile/SmartButton/btn-betp-up@3x.png?0.0.53";